import type { Subscription } from 'core/interfaces/billing';

declare const gtag: Function;

// Google Ads account the Hairio quiz reports to (DEV-1138). The previous account
// AW-17149973324 is no longer accessible, so only the trial purchase conversion
// is reported now; paywall view / email / upsale conversions were dropped.
export const GOOGLE_ADS_ID = 'AW-18510871286';
const TRIAL_CONVERSION_LABEL = 'z5yrCOva0awdEPb11fpE';

/**
 * Reports a successful trial purchase to Google Ads.
 *
 * `transaction_id` is required: Google dedupes conversions by it and Magnus later
 * adjusts the conversion value by the same id, so it must be the real payment id.
 */
export const trackGoogleAdsTrialConversion = (
  purchase?: Partial<Subscription> | null,
  product?: any
) => {
  if (typeof gtag !== 'function') return;

  const value = Number(
    product?.trialPriceAmount || product?.amount || purchase?.amount || purchase?.order?.amount || 0
  );
  const currency = String(
    purchase?.currency || purchase?.order?.currency || product?.currency || 'USD'
  ).toUpperCase();
  const transactionId =
    purchase?.transaction_id ||
    purchase?.subscription_id ||
    purchase?.order?.order_id ||
    purchase?.id ||
    '';

  gtag('event', 'conversion', {
    send_to: `${GOOGLE_ADS_ID}/${TRIAL_CONVERSION_LABEL}`,
    value,
    currency,
    transaction_id: transactionId,
  });
};
